<template>
  <div style="text-align:center">
    <div class="row mt-3">
      <div class="col-12">
        <div class="card announcement">
          <h4>This software program, including any documentation and media (Software), is protected by copyright laws and
            international treaty, and is a proprietary product of Innovdigi.com. The use of this Software is also governed
            by the terms of the Software License Agreement on the reverse side (Agreement). Keep this License in a safe
            place, as it is your proof of purchase and may be required for upgrade or support services.</h4>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-4">
        <div class="card announcement">
          <h5>Front Office / Student & Teachers Module</h5>
          <h3>AS0023485AAIS</h3>
        </div>
      </div>
      <div class="col-4">
        <div class="card announcement">
          <h5>Alumni Information Database Module</h5>
          <h3>AS0023486AAIS</h3>
        </div>
      </div>
      <div class="col-4">
        <div class="card announcement">
          <h5>Administration Module</h5>
          <h3>AS0023487AAIS</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Serial Number" }]);
  }
}
</script>


<style scoped>
@import "../../assets/css/dashboard.css";
</style>